export function formatDialogId(id, type = '') {
    /**
     * Can be used for aria dialog id generation.
     * Both with and without the type argument.
     */
    return 'dialog-' + id  + ((type) ? '-' + type : '');
}

export function formatAriaLabel(str = "") {
    /**
     * Format str to kebab-case for aria labels.
     */
    return str.replace(/([a-z])([A-Z])/g, "$1-$2")
              .replace(/[\s_]+/g, '-')
              .toLowerCase();

}
